import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../shared/themes/redesignTokens";

// ═══════════════════════════════════════════════════════════════
//  ContextInfoRow — generic single-line info row (icon + children)
//  Used in the card context panel for per-stage data rows.
// ═══════════════════════════════════════════════════════════════

interface ContextInfoRowProps {
  /** Icon element (MUI icon, 14px recommended) */
  icon: React.ReactNode;
  /** Content to render next to the icon */
  children: React.ReactNode;
  /** Optional text color override (defaults to dt.textSecondary) */
  color?: string;
}

const ContextInfoRow: React.FC<ContextInfoRowProps> = ({
  icon,
  children,
  color,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "12px",
      fontFamily: dt.font,
      color: color || dt.textSecondary,
      fontWeight: 500,
    }}
  >
    {icon}
    <Box sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
      {children}
    </Box>
  </Box>
);

export default ContextInfoRow;
